import styled from 'styled-components'

export const LoadingCSS = styled.div`
  background-color: rgba(255, 255, 255, 0.6);
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 200;

  & > img {
    margin: auto;
  }

  & > span {
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px !important;
    height: 50px !important;
  }

  &.form-login {
    position: relative;

    & > span {
      position: relative !important;
      transform: translate(-50%, 0);
    }
  }
`
